<template>
<div class="chapter">
<div class="inner_page">
<h1 class="cht" id="ch_1"><a id="page_9"></a><a href="#/Text/contents#ch1"><b>Virgin Mary, Put Putin</b> Away <b>(Punk Prayer)</b></a></h1>
<p class="noindent">(Chorus)<br/>
  Virgin Mary, Mother of God, put Putin away<br/>
  Put Putin away, put Putin away!<br/>
  (End chorus)</p>
<p class="noindents">Black robe, golden epaulettes<br/>
  All parishioners crawl to bow<br/>
  The phantom of liberty is in heaven<br/>
  Gay pride sent to Siberia in chains</p>
<p class="noindents">The head of the KGB, their chief saint,<br/>
  Leads protesters to prison under escort<br/>
  In order not to offend His Holiness<br/>
  Women must give birth and love</p>
<p class="noindents">Shit, shit, the Lord’s shit!<br/>
  Shit, shit, the Lord’s shit!</p>
<p class="noindents">(Chorus)<br/>
  Virgin Mary, Mother of God, become a feminist<br/>
  Become a feminist, become a feminist!<br/>
  (End chorus)</p>
<p class="noindents">The church’s praise of rotten dictators<br/>
  The cross-bearer procession of black limousines<br/>
  A teacher-preacher will meet you at school<br/>
  Go to class—bring him money!</p>
<p class="noindents">Patriarch Gundyaev believes in Putin<br/>
  Bitch, better believe in God instead!<br/>
  The belt of the Virgin can’t replace mass meetings<br/>
  Mary, Mother of God, is with us in protest!</p>
<p class="noindents">(Chorus)<br/>
  Virgin Mary, Mother of God, put Putin away<br/>
  Put Putin away, put Putin away!<br/>
  (End chorus)</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter1.vue?3b8bca26